// Device and browser information utilities
export function getDeviceInfo() {
  let ua;
  try {
    ua = navigator.userAgent || '';
  } catch (e) {
    ua = '';
  }
  let deviceType = "desktop";
  let manufacturer = "unknown";
  let model = "unknown";

  // Device type detection
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    deviceType = "tablet";
  } else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    deviceType = "mobile";
  }

  // Try modern API first
    // Parse manufacturer and model from user agent
    if (/iPhone/.test(ua)) {
      manufacturer = "Apple";
      model = ua.match(/iPhone OS ([\d_]+)/)?.[0] || "iPhone";
    } else if (/iPad/.test(ua)) {
      manufacturer = "Apple";
      model = "iPad";
    } else if (/Android/.test(ua)) {
      manufacturer = "Android";
      const modelMatch = ua.match(/Android[^;]*;\s*([^)]+)/);
      model = modelMatch?.[1]?.trim() || "Android Device";
    } else if (/Windows/.test(ua)) {
      manufacturer = "Microsoft";
      model = "Windows PC";
    } else if (/Mac/.test(ua)) {
      manufacturer = "Apple";
      model = "Mac";
    }
  // }

  let screenWidth = "unknown";
  let screenHeight = "unknown";
  
  try {
    if (window.screen) {
      screenWidth = window.screen.width.toString();
      screenHeight = window.screen.height.toString();
    }
  } catch (e) {
    // Screen API not available
  }

  return {
    type: deviceType,
    manufacturer,
    model,
    screen: {
      width: screenWidth,
      height: screenHeight,
    },
    device_id: (() => {
      try {
        return getTabId();
      } catch (e) {
        return 'unknown';
      }
    })(),
  };
}

export function getBrowserInfo() {
  let name = null;
  let version = null;

  if (!name) {
    const ua = navigator.userAgent;
    if (ua.includes("Chrome") && !ua.includes("Edg")) name = "Chrome";
    else if (ua.includes("Edg")) name = "Edge";
    else if (ua.includes("Safari") && !ua.includes("Chrome")) name = "Safari";
    else if (ua.includes("Firefox")) name = "Firefox";
    else if (ua.includes("MSIE") || ua.includes("Trident")) name = "IE";
    else name = "Unknown";
  }

  if (!version) {
    const match = navigator.userAgent.match(/(Chrome|Firefox|Safari|MSIE|Trident)\/([\d.]+)/);
    version = match ? match[2] : null;
  }

  return {
    name,
    language: navigator.language || null,
    version,
    user_agent: navigator.userAgent,
  };
}

export function getOSInfo() {
  const ua = navigator.userAgent;
  let name = "unknown";
  let version = "unknown";

  // Try modern API first

    // Fallback to user agent parsing
    if (/Windows NT (\d+\.\d+)/.test(ua)) {
      name = "Windows";
      const match = ua.match(/Windows NT (\d+\.\d+)/);
      const ntVersion = match[1];
      const versionMap = {
        "10.0": "10/11",
        "6.3": "8.1",
        "6.2": "8",
        "6.1": "7"
      };
      version = versionMap[ntVersion] || ntVersion;
    } else if (/Mac OS X ([\d_]+)/.test(ua)) {
      name = "macOS";
      const match = ua.match(/Mac OS X ([\d_]+)/);
      version = match[1].replace(/_/g, ".");
    } else if (/Android ([\d.]+)/.test(ua)) {
      name = "Android";
      version = ua.match(/Android ([\d.]+)/)[1];
    } else if (/iPhone OS ([\d_]+)/.test(ua)) {
      name = "iOS";
      version = ua.match(/iPhone OS ([\d_]+)/)[1].replace(/_/g, ".");
    } else if (/Linux/.test(ua)) {
      name = "Linux";
    }

  return { name, version };
}

export function getNetworkType() {
  if (typeof navigator !== "undefined" && "connection" in navigator) {
    const { connection } = navigator;
    return connection?.type || connection?.effectiveType || 'unknown';
  }
  return 'unknown';
}

export function getTabId() {
  try {
    if (!sessionStorage.getItem("tabId")) {
      const tabId = crypto.randomUUID ? crypto.randomUUID().replace(/-/g, "") : Date.now().toString() + Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem("tabId", tabId);
    }
    return sessionStorage.getItem("tabId");
  } catch (e) {
    return Date.now().toString() + Math.random().toString(36).substr(2, 9);
  }
}